module.exports = __webpack_public_path__ + "img/course_bg02.90b424e8.png";